<template>
    <div class="tabs-supervisors panel panel-default">
        <ul class="nav nav-tabs">
            <li :class="{active: activated == 1}">
                <a @click="activated = 1">
                    Активные
                </a>
            </li>
            <li :class="{active: activated == 0}">
                <a @click="activated = 0">
                    Деактивированные
                </a>
            </li>
        </ul>

        <list-supervisors activated="1" v-show="activated == 1"></list-supervisors>
        <list-supervisors activated="0" v-show="activated == 0"></list-supervisors>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        activated: 1,
      }
    },
  }
</script>

<style lang="less">
    @import "../../less/_boot";

    .tabs-supervisors {
        .nav-tabs {
            border-width: 0;
            > li {
                > a {
                    font-size: 15px;
                    line-height: 81px;
                    color: #727378;
                    padding: 0px 40px;
                    text-transform: uppercase;
                    letter-spacing: 0.03em;
                    cursor: pointer;
                    border-width: 3px 0 0 !important;
                    border-color: transparent;
                    border-radius: 0;
                    &:hover {
                        background-color: transparent;
                    }
                }
                &.active > a {
                    border-top: 3px solid @brand-primary;
                    color: @brand-primary;
                    background-color: #fff;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// TabsSupervisors.vue?10523de6